import { ROUTE_PATHS } from 'Constants/routing';
import { useUIStore } from 'Modules/ui/index.store';
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';

const isInConversationRegex = new RegExp(`^(${ROUTE_PATHS.latestChat.path})`);

const useEntityPanel = () => {
  const location = useLocation();

  const { entitySidePanelInfo, resetEntitySidePanel } = useUIStore();

  const previousPathname = useRef(location.pathname);

  /**
   * Closes the side panel when the user moves from a conversation page to a non-conversation page.
   */
  useEffect(() => {
    if (
      !isInConversationRegex.test(location.pathname) &&
      previousPathname.current !== location.pathname
    ) {
      resetEntitySidePanel();
    }

    previousPathname.current = location.pathname;
  }, [location.pathname, resetEntitySidePanel]);

  return {
    isOpen:
      (!!entitySidePanelInfo?.entityId && !entitySidePanelInfo?.isLoading) ||
      !!entitySidePanelInfo?.contact ||
      !!entitySidePanelInfo?.groupConversationId,
  };
};

export default useEntityPanel;
